import React from 'react';
import { PN_BLUE } from '../../PN/const';

const SVG = ({ style = {}, color = PN_BLUE, width = '100%', viewBox = '0 0 100 100' }) => (
  <svg style={{ ...style, display: 'block' }} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
    <g fill={color} stroke="white" strokeWidth="4">
      <path
        d="M20,30 
        C20,-8 80,-8 80,30 
        C80,50 60,50 60,62 
        C60,74 40,74 40,62 
        C40,52 40,50 59,35
        C61,33 61,30 61,30
        C63,13 40,13 40,30 
        C40,40 20,40 20,30"
      />
      <circle cx="50" cy="88" r="10" />
    </g>
  </svg>
);

export default SVG;
